import {
  PenpalContextProvider,
  usePenpal,
} from "@saasquatch/integration-boilerplate-react";
import {
  ButtonView,
  CSSVariables,
  FontFamilyRules,
  InputView,
  LinkRules,
  LoadingSpinner,
  registerUICL,
} from "@saasquatch/visual-dev";
import "@saasquatch/visual-dev/dist/assets/impact/style.css";
import React, { useState } from "react";
import { render } from "react-dom";
import "./styles.css";

type EditorState = {
  formData: {
    appsFlyerLink: string;
  };
};

const isEmpty = (value: { [key: string]: string }) => {
  return (
    !value ||
    (Object.keys(value).length === 0 && value.constructor === Object) ||
    !value.appsflyerLink
  );
};

function Index() {
  const penpal = usePenpal();
  const config = penpal.integrationConfig as { appsflyerLink: string };
  const useDefault = isEmpty(config);

  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState(
    useDefault ? { appsflyerLink: "" } : config
  );
  const [error, setError] = useState("");

  if (customElements.get("uicl-btn") === undefined) {
    registerUICL();
  }

  function validateLink(formData: any) {
    const input = formData.appsflyerLink;
    if (
      (input &&
        !(input.startsWith("https://") || input.startsWith("http://"))) ||
      input === "" ||
      input === undefined
    ) {
      const error = "You must enter a valid AppsFlyer attribution link";
      setError(error);
      return error;
    }
    setError("");
    return "";
  }

  async function submit(e: React.MouseEvent) {
    if (!e.isTrusted) return;

    setSaving(true);
    if (validateLink(formData)) return setSaving(false);

    // @ts-ignore
    await penpal.saveIntegrationConfig(formData);
    setSaving(false);
  }

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setFormData({ appsflyerLink: event.target.value });
    validateLink({ appsflyerLink: event.target.value });
  }

  return (
    <div className="container">
      <div className="description">
        <p>
          Connect your custom AppsFlyer OneLink attribution link for mobile
          redirection and deep linking.
          <br />
          <br />
          <span style={{ fontWeight: 700 }}>Set Up Steps</span>
        </p>
        <ol>
          <li>Create a OneLink Template in AppsFlyer</li>
          <li>
            Configure a custom link with your desired redirection settings
          </li>
          <li>
            Leave the Desktop redirection URL empty. This will be pulled from
            your {penpal.flavor === "impact" ? "Advocate" : "SaaSquatch"}{" "}
            program settings.
          </li>
          <li>Copy and paste the short URL for your custom link below. </li>
        </ol>
        <p>
          <br />
          This link will be used as the redirct for all of your active
          {penpal.flavor === "impact" ? "Advocate" : "SaaSquatch"} programs.
          <br />
        </p>
      </div>

      <label htmlFor="appsFlyerLink">AppsFlyer Base Attribution Link</label>
      <br />
      <InputView
        name="appsflyerLink"
        onChange={onChange}
        value={useDefault ? "" : config.appsflyerLink}
        autoFocus
        placeholder={"https://app.onelink.me/templateId/linkId"}
        errors={!!error}
      />
      {error && <li style={{ color: "#c13333" }}>{error}</li>}
      <ButtonView
        buttonType="primary"
        type="submit"
        onClick={submit}
        disabled={!!error}
        loading={saving}
        style={{ marginTop: "12px" }}
      >
        Save
      </ButtonView>
    </div>
  );
}

function App() {
  return (
    <PenpalContextProvider
      loading={<LoadingSpinner.Large />}
      fallback={
        <p>Integration configuration must be done inside the product.</p>
      }
    >
      <CSSVariables /> <LinkRules /> <FontFamilyRules />
      <Index />
    </PenpalContextProvider>
  );
}

const rootElement = document.getElementById("root");
render(<App />, rootElement);
